<template>
  <div class="feedback-pictures">
    <div class="feedback-pictures-header">
      <h2>Pictures</h2>
      <button
        class="hw-btn hw-btn-outline"
        @click="$emit('open-upload-modal')"
      >
        Upload Pics
      </button>
    </div>
    <hr class="mt-3">
    <v-flex class="images-container">
      <template>
        <div v-for="(image, index) in images" :key="index">
          <v-hover>
            <div
              slot-scope="{hover}"
              class="images-container-placeholder"
            >
              <img :src="image.fileURL ? image.fileURL : image">
              <v-fade-transition>
                <v-layout v-if="hover" class="image-hover white--text">
                  <v-flex>
                    <v-icon
                      :color="colors.hwayzWhite"
                      class="hover-icon"
                      title="delete"
                      @click="$emit('remove-image', image)"
                    >
                      fas fa-trash-alt
                    </v-icon>
                  </v-flex>
                </v-layout>
              </v-fade-transition>
            </div>
          </v-hover>
        </div>
      </template>
    </v-flex>
  </div>
</template>

<script>
import colors from '../../scss/_colors.scss'
export default {
  props: {
    images: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      colors
    }
  }
}
</script>

<style lang="sass">
  .feedback-pictures
     h2
      font-size: 20px
      line-height: 37px
      font-weight: 400
      text-transform: capitalize
      color: #373737
      margin-bottom: 10px
  .images-container
    width: 85%
    max-height: 400px
    margin: 36px auto 0
    overflow: auto
    display: flex
    flex-direction: row
    justify-content: center
    flex-wrap: wrap
    div
      margin: 0.5rem

    &-placeholder
      height: 160px
      width: 268px
      border: .1rem solid $hwayzce
      display: flex
      flex-flow: column
      align-items: center
      justify-content: center
      border-radius: 20px
      position: relative

      img
        height: 100%
        width: 100%
        border-radius: 20px
        margin: 10px

      .image-hover
        pointer-events: none
        position: absolute
        bottom: 0
        top: 0
        left: 0
        right: 0
        margin: 0 !important
        background-color: grey
        opacity: 0.9
        color: $hwayzWhite
        border-radius: 20px

        .hover-icon
          pointer-events: all
          font-size: $hwayzFont1rem6
          position: absolute
          bottom: 10px !important
          right: 10px !important
          cursor: pointer
</style>
